import { Col, Row, Tag } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { ButtonType, TAButton } from '../../widgets';

const DEFAULT_FEATURE_COLOR = '#F6895E';

const PlanContainer = styled.div`
	padding: 15px 20px;
	background: #ffffff;
	box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.08);
	border-radius: 8px;
	margin: 10px;
	border: 1px solid transparent;
	transition: 0.3s border;

	.title {
		font-weight: 500;
		font-size: 1rem;
		color: #212121;
		margin-right: 8px;
	}

	&:hover {
		border: 1px solid ${({ theme }) => theme.TA_GREEN};
	}
`;

const PlanCard = ({ title, body, children, price, btnText = 'Choose Plan', features, onSelect }: any) => {
	return (
		<PlanContainer>
			<Row className="mb-3 text-center text-md-start">
				<span className="title">{title}</span>
				{features &&
					features.map(t => <Tag color={t.color || DEFAULT_FEATURE_COLOR}>{t.name.toUpperCase()}</Tag>)}
			</Row>
			<Row className="d-flex flex-column flex-md-row align-items-center">
				<Col className="d-flex justify-content-center justify-content-md-start" xs={24} md={{ span: 14 }}>
					<div className="d-flex flex-column justify-content-start ">
						{/* {featuresText.length
							? featuresText.map(feature => {
									return (
										<span>
											<Icon
												type="check"
												className="me-2"
												style={{ fontSize: '1.5rem', fontWeight: '700', color: '#67D9AE' }}
											/>
											{feature}
										</span>
									);
							  })
							: null} */}
						{body || children}
					</div>
				</Col>
				<Col className="d-flex flex-column align-items-center" xs={24} md={{ span: 10, push: 0 }}>
					<span style={{ fontSize: '2rem', fontWeight: 500, color: '#000' }}>USD {price}</span>
					<TAButton btntype={ButtonType.PRIMARY} onClick={onSelect}>
						{btnText}
					</TAButton>
				</Col>
			</Row>
		</PlanContainer>
	);
};

export default PlanCard;
